export enum ETipoCliente {
    ApenasPessoaFisica = 1,
    ApenasPessoaJuridica = 2,
    AmbosPessoaFisicaJuridica = 3,
}
